import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TakeoutDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"takeout_dining"}/>
}
